import { onSetLifeCycleForSessions, onUpdateExtractorSession } from "common/signalR";
import { ArtistSidePanel } from "components/SidePanel/Company/CompanySidePanel";
import SmallDetails from "components/SmallDetails/SmallDetails";
import ExtractorSessionLifeCyclePill from "extractorSession/ExtractorSessionLifeCyclePill";
import moment from "moment";
import React, { useEffect, useState } from "react";

interface Props {
  item: server.dto.ExtractorSession
}

export const ExtractorSessionTitle = (props: Props) => {
  const [item, setItem] = useState(props.item);

  useEffect(() => {
    const res = onUpdateExtractorSession(newItem => {
      if (newItem.extractorSessionId === item.extractorSessionId) {
        setItem(newItem);
      }
    });

    const res2 = onSetLifeCycleForSessions(newItem => {
      if (newItem.extractorSessionIds.includes(item.extractorSessionId)) {
        setItem(prev => ({ ...prev, lifeCycle: newItem.lifeCycle }));
      }
    });

    return () => {
      res.removeEvent();
      res2.removeEvent();
    }
  }, [item.extractorSessionId]);

  return <div className="flex gap">
    <div style={{ width: 160 }}>
      <ArtistSidePanel
        companyId={item.artist.artistId}
        trigger={<a>{item.artist.name}</a>}
      />
    </div>
    <div className="grow1">
      {item.sourcePdfFileName ? <SmallDetails
        link={window.CoreApi.Extractor.DownloadSessionFile.absoluteUrl(item.extractorSessionId)}
        label={`${item.sourcePdfFileName}.pdf`}
        subLabel={`${RESX.File.UploadedBy} ${item.owner.fullName} ${moment.utc(item.createdUtc).fromNow()}`}
      /> : <SmallDetails
        label="Pasted text"
        subLabel={`${RESX.File.UploadedBy} ${item.owner.fullName} ${moment.utc(item.createdUtc).fromNow()}`}
      />}
    </div>
    <div>
      <ExtractorSessionLifeCyclePill lifeCycle={item.lifeCycle} />
    </div>
  </div>
}